import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
// import { DatePicker } from 'tea-component';
import YearRangePicker from '@gp/components/TeaRangePicker';
import {
  getDateRangeOfTeaComponent,
  getDateValueOfTeaComponent,
  formatDateValueOfTeaComponent,
} from '../../utils';

import type { IBaseProps } from '@home/types/common';
import type { IGranularity, IDateValue } from '../../types';

import './index.scss';

// import calendarSvg from '@gp/assets/svg/calendar.svg';

// const { RangePicker } = DatePicker;

const GRANULARITIES_OF_YEAR_SELECT = ['year'];

interface IDateSelectProps extends IBaseProps {
  loading: boolean;
  range?: {
    month: IDateValue;
    quarter: IDateValue;
    year: IDateValue;
  };
  granularity: IGranularity;
  value: IDateValue;
  onChange?: (date: IDateValue) => void;
}

const DateSelect: React.FC<IDateSelectProps> = (props) => {
  const {
    style,
    className,
    loading = true,
    range,
    granularity = 'quarter',
    value,
    onChange,
    showShortcut = false,
  } = props;
  const getDisabledConfig = (
    granularity: IGranularity,
    date: moment.Moment,
    range?: IDateValue,
  ): boolean => {
    const dateTimestamp = moment(date)?.valueOf();
    const allowStartTime = moment(range?.[0])?.startOf(granularity)?.valueOf();
    const allowEndTime = moment(range?.[1])?.endOf(granularity)?.valueOf();
    return dateTimestamp >= allowStartTime && dateTimestamp <= allowEndTime;
  };

  const handleChange = (payload: moment.Moment[]) => {
    const valueTmp = formatDateValueOfTeaComponent(payload);
    onChange?.(valueTmp);
  };

  return (
    <div style={style} className={classnames('dbg-filter-date-picker-selector font14', className)}>
      <>
        {/* 禁用与Loading */}
        {(loading || !range) && (
          <div className="calendar-filter-date-picker-loading">
            <span className="loading-text loading-text-one">
              {loading ? 'Loading...' : 'Select Date'}
            </span>
            <span className="loading-text loading-text-two">
              {loading ? 'Loading...' : 'Select Date'}
            </span>
            {/* <img className="loading-calendar-icon" width={16} height={16} src={calendarSvg} alt="" /> */}
          </div>
        )}
        {granularity === 'month' && (
          <YearRangePicker
            className="calendar-filter-date-month-selector"
            separator="~"
            showShortcut={showShortcut}
            showLabelPrefix={false}
            showSelectType={false}
            type="month"
            disabledQuarter={(date) => getDisabledConfig(granularity, date, range?.month)}
            allowRange={getDateRangeOfTeaComponent('month', range?.month)}
            value={getDateValueOfTeaComponent(loading, 'month', value)}
            onChange={handleChange}
            overlayClassName={'dbg-filter-date-picker-show-shortcut'}
          />
        )}
        {granularity === 'quarter' && (
          <YearRangePicker
            className="calendar-filter-date-quarter-selector"
            separator="~"
            showShortcut={showShortcut}
            // startOfTime={minDate}
            // endOfTime={minDate}
            showLabelPrefix={false}
            showSelectType={false}
            type="quarter"
            disabledQuarter={(date) => getDisabledConfig(granularity, date, range?.quarter)}
            allowRange={getDateRangeOfTeaComponent('quarter', range?.quarter)}
            value={getDateValueOfTeaComponent(loading, 'quarter', value)}
            onChange={handleChange}
            overlayClassName={'dbg-filter-date-picker-show-shortcut'}
          />
        )}
        {granularity === 'year' && (
          <YearRangePicker
            className="calendar-filter-date-year-selector"
            showShortcut={showShortcut}
            showLabelPrefix={false}
            showSelectType={false}
            type="year"
            startOfWeek={0}
            language="en"
            typeList={GRANULARITIES_OF_YEAR_SELECT}
            allowRange={getDateRangeOfTeaComponent('year', range?.year)}
            value={getDateValueOfTeaComponent(loading, 'year', value)}
            onChange={handleChange}
            overlayClassName={'dbg-filter-date-picker-show-shortcut'}
          />
        )}
      </>
    </div>
  );
};

export default DateSelect;
